export const environment = {
  // Block F12 / Ctrl+Shift+I / right-click on the portal (always off on localhost)
  blockDevTools: false,
  production: false,

  // 🔹 existing configs
  // apiUrl: 'https://dev-api.pouch.site',
  apiUrl: 'https://dev-api.pouch.site',
  imageUrl: '',
  fileUrl: '',
  defaultPlaceholder: '/images/default_placeholder.png',
  otp_time: 10, // seconds
  otp_timerValue: '00:10',
  dateFormat: 'DD, MMMM YYYY',
  dateMonthFormat: 'DD MMMM',
  dateFormatTable: 'MMM d, y',

}; 
